export function loadFbSdk(appId, version) {
  return new Promise((resolve) => {
    if (typeof window.fbAsyncInit !== 'undefined') {
      resolve('SDK already loaded');
      return;
    }

    window.fbAsyncInit = function () {
      // eslint-disable-line func-names
      window.FB.init({
        appId,
        autoLogAppEvents: true,
        xfbml: true,
        version,
        cookie: true,
      });
      window.FB.AppEvents.logPageView();
      resolve('SDK Loaded!');
    };
    (function (d, s, id) {
      // eslint-disable-line func-names
      const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      const js = d.createElement(s);
      js.id = id;
      js.src = '//connect.facebook.net/en_US/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');
  });
}

export function getFbLoginStatus() {
  return new Promise((resolve) => {
    window.FB.getLoginStatus((responseStatus) => {
      resolve(responseStatus);
    });
  });
}

export function fbLogin(options) {
  return new Promise((resolve) => {
    window.FB.login((response) => resolve(response), options);
  });
}

export function fbLogout() {
  return new Promise((resolve) => {
    window.FB.logout((response) => resolve(response));
  });
}

export function fbApi(url, options = {}) {
  return new Promise((resolve) => {
    window.FB.api(url, options, (response) => resolve(response), options);
  });
}
